export const AGGREGATES = {
  MAX_ERRORS: 50,
} as const;
